import React from "react";
import { Col, Row } from "antd";
import { connect } from "dva";
import TripCard from "./TripCard";

const breakPoints = { xs: 24, sm: 24, md: 12, lg: 12 };

const TripDetails = ({ shipmentData, vehicleAndLoadData }) => {
  const originData = {
    ...shipmentData.pickupAddress,
    eta: shipmentData.load?.pickupETA,
    etaTimeSlot: shipmentData.load?.pickupETATimeSlot,
    actual: vehicleAndLoadData?.load?.pickedUpAt,
    daysOfWeekUnavailable: shipmentData?.pickup?.dayOfWeekRestricted || null,
  };

  const destinationData = {
    ...shipmentData.dropOffAddress,
    eta: shipmentData.load?.dropOffETA,
    etaTimeSlot: shipmentData.load?.dropOffETATimeSlot,
    actual: vehicleAndLoadData?.load?.droppedOffAt,
    daysOfWeekUnavailable: shipmentData?.dropoff?.dayOfWeekRestricted || null,
  };

  return (
    <Row justify="space-between" gutter={[16, 16]} style={{ marginLeft: 16 }}>
      <Col {...breakPoints}>
        <TripCard tripTime="Pickup" data={originData} />
      </Col>

      <Col {...breakPoints}>
        <TripCard tripTime="Dropoff" data={destinationData} />
      </Col>
    </Row>
  );
};

export default connect(({ shipmentDetails }) => ({
  shipmentData: shipmentDetails.data,
  vehicleAndLoadData: shipmentDetails.vehicleAndLoadData[0],
}))(TripDetails);
